import { GridColDef, GridInitialState } from '@mui/x-data-grid-pro';
import { FC } from 'react';

import { formatKundeAdresse } from '../../../components/formatUtils';
import { formatDate } from '../../../components/formatUtils/dateFormatUtils';
import { AppDataGrid } from '../../../components/table/AppDataGrid';
import { useFindAllKundeQuery } from '../api/kundeApi';
import { KontaktTyp, Kunde } from '../api/types';

export const kundeTableColumns: GridColDef[] = [
  {
    field: 'organisation',
    headerName: 'Organisation',
    flex: 2,
  },
  {
    field: 'operativerAnsprechpartner',
    headerName: 'Operativer Ansprechpartner',
    flex: 2,
  },
  {
    field: 'strasse',
    headerName: 'Strasse',
    flex: 1,
  },
  {
    field: 'hausnummer',
    headerName: 'Hausnummer',
    flex: 1,
  },
  {
    field: 'adresszusatz',
    headerName: 'Adresszusatz',
    flex: 1,
  },
  {
    field: 'postleitzahl',
    headerName: 'Postleitzahl',
    flex: 1,
  },
  {
    field: 'stadt',
    headerName: 'Stadt',
    flex: 1,
  },
  {
    field: 'adresse',
    headerName: 'Adresse',
    flex: 1,
    valueGetter: (value, row) => formatKundeAdresse(row as Kunde),
  },
  {
    field: 'creationDate',
    headerName: 'Angelegt am',
    flex: 1,
    type: 'date',
    valueFormatter: value => formatDate(value as string),
  },
];

const kundeGridVisibilitySettings: GridInitialState = {
  columns: {
    columnVisibilityModel: {
      strasse: false,
      hausnummer: false,
      adresszusatz: false,
      postleitzahl: false,
      stadt: false,
    },
  },
};

export const KundeTable: FC = () => {
  const { data: kunden = [], isFetching } = useFindAllKundeQuery();
  const kundenOnly = kunden.filter(kunde => kunde.typ === KontaktTyp.KUNDE);

  return (
    <AppDataGrid
      checkboxSelection={true}
      loading={isFetching}
      columns={kundeTableColumns}
      rows={kundenOnly}
      initialState={kundeGridVisibilitySettings}
    />
  );
};
